export default __webpack_public_path__ + "static/media/PrintsImage04.e0bfc05d.jpg";